import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import { preferenceEnums } from "../../../../system/global-enums";
import { getOptionsFromEnums } from "../../../../shared/utility";

const options = getOptionsFromEnums(preferenceEnums.AGE_RANGE);

const AgeForm = () => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className="question-heading">What is your age?</div>
        {errors.ageGroup && (
          <div className="error">{errors.ageGroup.message}</div>
        )}
      <div className="form-fields">
        {options.map((option) => (
          <SurveyFormField
            key={option.value}
            name="ageGroup"
            variant="radio"
            label={option.label}
            value={option.value}
          />
        ))}
      </div>
    </div>
  );
};

export default AgeForm;
